
class ConfLoader {
  configuration = {}

  constructor (ctx = null) {
    // load configuration files
    // let loader = require.context('@/conf/entities/', true, /^(.*backoffice.*\.(json$))$/) // Non fonctionnel car ctx non variable
    let loader = require.context('@/conf/entities/', true, /^(.*\.(json$))$/)

    let configuration = {}
    loader.keys().forEach(function (key) {
      // Utilisé pour ne loader que la conf correspondante au context
      if (ctx != null && !key.includes('/' + ctx + '/')) return
      let subconf = loader(key)
      configuration[subconf.entityName] = subconf
    })
    this.configuration = configuration
  }

  getConfiguration () {
    return this.configuration
  }
}

export default ConfLoader
